import React, { useEffect,useContext, useState } from "react";
import "../genericModels.css";
import { modelCarActions } from "../../service/modelcar.actions";
import Box from "@mui/material/Box";
import { useTranslation } from "react-i18next";
import { CarModelFilterAndSearch } from "./CarModelFilterAndSearch";
import FileSaver from "file-saver";
import { CarModelMainTitle } from "./CarModelMainTitle";
import { GlobalContext } from  "../../../../util/state/GlobalContextProvider";
import { setSnackbar } from "../../../../util/state/globalAction";
import { snackbarTypes } from "../../../../util/state/globalVariables";
import CustomLoader from "../../../../util/component/CustomLoader";
import AgGridCustomTable from "../../../../util/component/AgGridCustomTable";
import { IServerSideGetRowsParams } from "ag-grid-community";
import { Card, IconButton, Stack, Tooltip, Typography } from "@mui/material";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import { ContextOperation } from "../../context/OperationContext";
import SectionHeader from "../../../../util/component/SectionHeader";
import AgGridOperationTable from "../common/AgGridOperationTable";

export default function CarModelTable() {
  const { t } = useTranslation(["operation"]);
  const userModelCar = modelCarActions();
  const { dispatchGlobalData } = useContext(GlobalContext);
  const { setLoading } = useContext(ContextOperation);
  let pageSize = 10;
  const [pageNumber, setPageNumber] = useState<number>(0);
  const [length, setLength] = useState<number>(0);
  const [resetFormValue, setResetFormValue] = useState<boolean>(false);
  const [loading, setIsLoading] = useState<boolean>(false);
  const [gridApi, setGridApi] = useState<any>(null);
  const [dataFormSearchField, setDataFormSearchField] = useState<any>({
    code: "",
    descr: "",
    codeBrand: "",
    descrBrand: "",
  });
  const {tenant} = useContext(ContextOperation);
  const columnDefs: any =[
    {
      field: "descr",
      headerName: t("carRange.description"),
      flex: 1,
      headerClass: "headerTableCarModel",
    },

    {
      field: "code",
      headerName: t("carRange.code"),
      flex: 1,
      headerClass: "headerTableCarModel",
    },
    {
      field: "descCode",
      headerName: t("brand.description"),
      flex: 1,
      headerClass: "headerTableCarModel classRight",
    },
    {
      field: "brandCode",
      headerName: t("brand.code"),
      flex: 1,
      headerClass: "headerTableCarModel",
    },
  ];

  const downloadExcelModel: any = async () => {
    setLoading(true);
    let  code = !!dataFormSearchField.code ? dataFormSearchField.code.trim() : null;
    let  descr = !!dataFormSearchField.descr ? dataFormSearchField.descr.trim() : null;
    let  codeBrand = !!dataFormSearchField.codeBrand ? dataFormSearchField.codeBrand.trim() : null;
    let  descrBrand = !!dataFormSearchField.descrBrand? dataFormSearchField.descrBrand.trim() : null;
    userModelCar
      .exportDataModelCar(
        tenant,
        code,
        descr,
        codeBrand,
        descrBrand
      )
      .then((response: any) => {
        setLoading(false);
        const filename =
          response.headers["content-disposition"].split("filename=")[1];
        var blob = new Blob([response.data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        FileSaver.saveAs(blob, filename);
      });
  };

  function resetFormText() {
   
    setDataFormSearchField((old: any) => ({
      ...old,
      code: "",
      descr: "",
      codeBrand: "",
      descrBrand: "",
    }));
    setResetFormValue(!resetFormValue);
  }

  const getModelCarParams = (
  ) => {
    setIsLoading(true);
    let  code = !!dataFormSearchField.code ? dataFormSearchField.code.trim() : null;
    let  descr = !!dataFormSearchField.descr ? dataFormSearchField.descr.trim() : null;
    let  codeBrand = !!dataFormSearchField.codeBrand ? dataFormSearchField.codeBrand.trim() : null;
    let  descrBrand = !!dataFormSearchField.descrBrand? dataFormSearchField.descrBrand.trim() : null;
    return {
      getRows: async (params: IServerSideGetRowsParams) => {
        const startRow = params.request.startRow ? params.request.startRow : 0;
        const endRow = params.request.endRow;
        
        if (endRow !== null && endRow !== undefined && startRow !== null && startRow !== undefined) {
          pageSize = endRow - startRow;
        }
        const pageNumber = startRow / pageSize
    userModelCar
      .getModelQueryParams(
        pageNumber,
        pageSize,
        tenant,
        code,
        descr,
        codeBrand,
        descrBrand
      )
      .then((response: any) => {
        params.successCallback(
          managerData(response),
          response.data.totalElements
          
        );
        
        setLength(response.data.totalElements)
         
        setIsLoading(false);
      })
      .catch((error: any) => {
        if (error.response) {
          dispatchGlobalData({
            type: setSnackbar,
            payload: {
                snackbar: {
                    message:error.response.data?.error,
                    type: snackbarTypes.error,
                    show: true,
                    autoClose: true,
                }
            }
        });
          setIsLoading(false);
        } else if (error.request) {
          dispatchGlobalData({
            type: setSnackbar,
            payload: {
                snackbar: {
                    message:(t("networkErrorMessage")),
                    type: snackbarTypes.error,
                    show: true,
                    autoClose: true,
                }
            }
        });
          setIsLoading(false);
        } else {
          setIsLoading(false);
        }
        setIsLoading(false);
      });
    },
  }
  };

  const onGridReady = (params: any) => {
    setGridApi(params.api);
  };

  function managerData(response: any) {
      let rows: any[] = [];
      response.data.content.forEach((element: any) => {
        let row = {
          code: element.code,
          descr: element.descr,
          brandCode: element.brand.code,
          descCode: element.brand.descr,
          id: element.id,
        };
        rows.push(row);
      });
      return rows;
  }

  

  useEffect(() => {
    if (gridApi) {
      gridApi.setServerSideDatasource(
    getModelCarParams());
    }
  }, [gridApi,resetFormValue]);

  return (
    <>
      <SectionHeader
          title={t("model.titleFirst") + " " + t("model.titleSecond")}
      />
      <CarModelFilterAndSearch
        dataFormSearchField={dataFormSearchField}
        setDataFormSearchField={setDataFormSearchField}
        // SearchModel={SearchModel}
        resetFormText={resetFormText}
        setResetFormValue ={setResetFormValue}
        resetFormValue ={resetFormValue}
        
      />

      <Box className="carGenericOuterTableBox">
        <Box>
        <Card >
       
        
            <Box minHeight={46} pr={1} display="flex" justifyContent={'flex-end'} alignItems="center" >
            <Tooltip  title={t("tooltipTitle.download")}>
            <IconButton color="accent" disabled ={length === 0 ?true:false} onClick ={downloadExcelModel}>
          <FileDownloadIcon/>
          </IconButton>
          </Tooltip>
          </Box>
         
        
        </Card>
        </Box>
        <Box>
        <AgGridOperationTable
            columnDefs={columnDefs}
            onGridReady={onGridReady}
            cacheBlockSize={pageSize}
            serverSideInfiniteScroll={true}
            rowModelType={"serverSide"}
            totalElements={length}

            />

          {loading && <CustomLoader loading={loading} />}
        </Box>
      </Box>
    </>
  );
}
